var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<ul class="CDB-Widget-list CDB-Widget-list--withBorders">\n  <li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n  <li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n  <li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n  <li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n</ul>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/cartodb-deep-insights.js/src/widgets/list/placeholder-template.tpl
// module id = 875
// module chunks = 2 3